import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import settingStore from './store';
import Switch from '@/components/switch';
import { HelperCore } from "@/common/helper";
import ReportWSModal from '@/components/modal/report-ws';

const handleKeyDown = event => {
  const shortcutKey = {
    functionKey: '',
    charKey: '',
  };

  if (event.ctrlKey) {
    shortcutKey.functionKey = 'Control';
  } else if (HelperCore.isMac()) {
    if (event.altKey) {
      shortcutKey.functionKey = 'Option';
    } else if (event.metaKey) {
      shortcutKey.functionKey = 'Command';
    }
  } else {
    if (event.altKey) {
      shortcutKey.functionKey = 'Alt';
    } else if (event.shiftKey) {
      shortcutKey.functionKey = 'Shift';
    }
  }

  if (
    event.keyCode &&
    ((event.keyCode >= 48 && event.keyCode <= 57) ||
      (event.keyCode >= 65 && event.keyCode <= 90))
  ) {
    shortcutKey.charKey = String.fromCharCode(event.keyCode);
  }

  if (shortcutKey.functionKey && shortcutKey.charKey) {
    settingStore.setShortCutKey(
      `${shortcutKey.functionKey} + ${shortcutKey.charKey}`
    );
  }
  event.preventDefault();
};

const ItemWrap = ({
  children,
  title,
  desc,
  noborder,
  onClick,
  className = '',
}) => {
  return (
    <div
      onClick={evt => {
        onClick && onClick();
      }}
      className={[
        'h-80px pb-8px flex items-center justify-between px-24px',
        noborder ? '' : 'border-b-1px border-black border-opacity-4',
        className,
      ]}
    >
      <div className="flex-shrink-0">
        <div className="text-16px leading-22px text-black font-bold">
          {title}
        </div>
        {desc ? (
          <div className="text-12px leading-17px text-black text-opacity-50 mt-2px">
            {desc}
          </div>
        ) : null}
      </div>
      {children}
    </div>
  );
};

function Setting() {
  const {
    open,
    placeholder,
    shortCutKeyCleared,
    userSetting,
    settingShortCutKey,
    updateSettingShortCutKey,
    setShortCutKeyCleared,
    setSlipperySearch,
    hide,
  } = settingStore;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (open) {
      settingStore.getSetting();
    }
    setShow(open);
  }, [open]);

  useEffect(() => {
    if (settingShortCutKey) {
      document.addEventListener('keydown', handleKeyDown);
    } else {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, [settingShortCutKey]);

  if (!open) return null;

  return (
    <div
      onClick={() => {
        updateSettingShortCutKey(false);
      }}
      className="fixed size-full inset-0 z-1000 overflow-hidden"
    >
      <div
        onClick={hide}
        className={[
          'size-full absolute inset-0 bg-black bg-opacity-40',
          'transform transition-opacity duration-500',
          show ? 'opacity-100' : 'opacity-0',
        ]}
      ></div>
      <div
        className={[
          !show ? 'translate-y-full' : '',
          'transform transition-translate duration-200',
          'absolute left-0 bottom-0 w-full h-7/10 min-h-410px bg-white rounded-t-16px',
        ]}
      >
        <div className="h-64px vh-center text-20px font-bold">
          <div className="">设置</div>
          <SVGPureIcon
            onClick={hide}
            name="modal_close"
            className="size-16px absolute top-24px right-24px cursor-pointer opacity-50 hover:opacity-100"
          />
        </div>
        <div className="pt-8px">
          {/* <ItemWrap title={'侧边悬浮头像'} desc={'始终悬浮在屏幕侧边'}>
            <Switch checked={true} onChange={() => {}} />
          </ItemWrap> */}
          <ItemWrap title={'划词工具栏'} desc={'始终在选中文字时显示'}>
            <Switch
              checked={userSetting.slipperySearch}
              onChange={flag => {
                setSlipperySearch(flag);
              }}
            />
          </ItemWrap>
          <ItemWrap
            title={'快捷键导航设置'}
            desc={'快捷键唤起侧边栏 可以点击切换'}
          >
            <div
              className={[
                'flex justify-between items-center ml-8px max-w-400px',
                'bg-[#F6F7F9] text-black border-[1px] cursor-pointer',
                'flex-grow w-0 h-[48px] rounded-[16px] px-[16px] text-[16px]',
                settingShortCutKey ? 'border-black' : 'border-[#F6F7F9]',
              ]}
              onClick={event => {
                event.stopPropagation();
                updateSettingShortCutKey(true);
              }}
            >
              {userSetting.shortcutKey ? (
                <>
                  {shortCutKeyCleared ? (
                    <div className="text-[#000] text-opacity-30 text-12px truncate">
                      {placeholder}
                    </div>
                  ) : (
                    userSetting.shortcutKey
                  )}
                  <SVGPureIcon
                    name="clear"
                    className={[
                      'size-18px cursor-pointer opacity-30 hover:opacity-60',
                      { hidden: shortCutKeyCleared },
                    ]}
                    onClick={event => {
                      event.stopPropagation();
                      updateSettingShortCutKey(true);
                      setShortCutKeyCleared(true);
                    }}
                  />
                </>
              ) : (
                <div className="opacity-30 font-bold">{placeholder}</div>
              )}
            </div>
          </ItemWrap>
          <ItemWrap
            onClick={evt => {
              ReportWSModal.show();
            }}
            title={'问题反馈'}
            className="cursor-pointer group"
            noborder
          >
            <SVGPureIcon
              name="icon_gt"
              className="w-7px h-12px cursor-pointer opacity-50 group-hover:opacity-100"
            />
          </ItemWrap>
        </div>
      </div>
    </div>
  );
}

const SettingComponent = observer(Setting);
export default SettingComponent;
